import { jsx } from "react/jsx-runtime";
import { Button, Text } from "pcln-design-system";
import { useContext } from "react";
import { ChatbotDataContext } from "../context/ChatbotDataContext.js";
import { handleBookHotelClick } from "./handleBookHotelClick.js";
const BookHotelNowButton = (props)=>{
    const { cguid, rguid, itemKey, priceKey, total, minCurrencyCode, minCurrencyCodeSymbol, buttonProps, checkIn, checkOut, submitMessages, hotelName, hotelId, args } = props;
    const { isMobile } = useContext(ChatbotDataContext);
    return /*#__PURE__*/ jsx(Button, {
        ...buttonProps,
        onClick: handleBookHotelClick({
            hotelName,
            hotelId,
            args,
            checkIn,
            checkOut,
            submitMessages,
            isMobile,
            cguid,
            rguid,
            itemKey,
            priceKey,
            total,
            minCurrencyCode,
            minCurrencyCodeSymbol
        }),
        children: /*#__PURE__*/ jsx(Text, {
            bold: true,
            fontSize: 0,
            children: "Book Now"
        })
    });
};
BookHotelNowButton.defaultProps = {
    buttonProps: {},
    cguid: '',
    rguid: '',
    itemKey: '',
    priceKey: '',
    total: '',
    minCurrencyCode: 'USD',
    minCurrencyCodeSymbol: '$'
};
export { BookHotelNowButton };
